import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { SiteContext } from "../context/SiteContext";
import { api } from "../services/api";
import "./PaginaArea.css";

export default function PaginaArea({ areaSlug }) {
  const { config } = useContext(SiteContext);
  const [areaData, setAreaData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [busca, setBusca] = useState("");

  useEffect(() => {
    async function fetchDocumentos() {
      if (!config?.id) return;

      try {
        setLoading(true);
        setAreaData(null);

        const response = await api.get(`/area/${areaSlug}?cliente=${config.id}`);
        setAreaData(response.data);
      } catch (error) {
        console.error("Erro ao buscar documentos da área:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchDocumentos();
  }, [config, areaSlug]);

  if (loading) {
    return (
      <div className="loader-container">
        <div className="hexagon-spinner"></div>
        <p className="loader-text">Buscando documentos...</p>
      </div>
    );
  }

  if (!areaData || !areaData.itens) {
    return (
      <div className="loader-container">
        <p className="loader-text" style={{ animation: "none" }}>
          Área indisponível ou em construção.
        </p>
      </div>
    );
  }

  const itensFiltrados = areaData.itens.filter((item) =>
    item.nome.toLowerCase().includes(busca.toLowerCase())
  );

  // Verifica se o item exige a tela de histórico/empilhamento
  const isEmpilhamento = (item) => {
    const nota = (item.nota || "").toLowerCase();
    return nota.includes("empilhamento");
  };

  // Verifica se possui um link válido cadastrado
  const hasValidLink = (item) => {
    return Boolean(item.link && item.link.trim() !== "" && item.link !== "#");
  };

  return (
    <div className="area-page-wrapper">
      <header className="area-header">
        <div className="container">
          <h1 className="area-title">{areaData.titulo}</h1>
          <p className="area-subtitle">{areaData.descricao}</p>
        </div>
      </header>

      <div className="container area-content">
        <div className="search-bar-container">
          <input
            type="text"
            className="search-input"
            placeholder={`Pesquisar em ${areaData.titulo}...`}
            value={busca}
            onChange={(e) => setBusca(e.target.value)}
          />
        </div>

        <div className="documents-grid">
          {itensFiltrados.length > 0 ? (
            itensFiltrados.map((item) => {
              const empilhamento = isEmpilhamento(item);
              const validLink = hasValidLink(item);

              return (
                <div
                  key={item.id}
                  className={`document-card ${!item.disponivel ? "indisponivel" : ""}`}
                >
                  <div className="doc-info">
                    <h3 className="doc-title">{item.nome}</h3>
                  </div>

                  <div className="doc-action">
                    {/* CENÁRIO 1: É empilhamento (vai para a tela de histórico) */}
                    {empilhamento && item.disponivel ? (
                      <Link
                        to={`/area/${areaSlug}/item/${item.id}`}
                        state={{ item, tituloArea: areaData.titulo }}
                        className="btn-acessar btn-empilhamento"
                      >
                        Ver Documentos ➔
                      </Link>
                    ) : /* CENÁRIO 2: É link comum (notícia, pdf, cadprev, link externo) */
                    item.disponivel && validLink ? (
                      <a
                        href={item.link}
                        className="btn-acessar"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Acessar ➔
                      </a>
                    ) : (
                      /* CENÁRIO 3: Indisponível ou sem link pronto */
                      <span className="badge-pendente">Em Atualização</span>
                    )}
                  </div>
                </div>
              );
            })
          ) : (
            <div className="empty-search">Nenhum documento encontrado com este nome.</div>
          )}
        </div>
      </div>
    </div>
  );
}